import { Container } from "./styles";
import githubIcon from "../../assets/github.svg";
// import DownloadApp from '../../assets/download.png'
import externalLink from "../../assets/external-link.svg";
import ScrollAnimation from "react-animate-on-scroll";

export function Project() {
  return (
    <Container id="project">
      <h2>My Projects</h2>
      <div className="projects">
        {/* Row 1 */}
         <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg
                width="50"
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#23ce6b "
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a
                  href="https://frontend-healthnex-c2jg.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>
                <a
                  href="https://github.com/raza2004/frontend-healthnex"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={githubIcon} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Health Nexus (AI Health Assistant)</h3>
              <p>
                Created HealthNexus, an AI powered medical platform using
                Next.js, Flask, ML models, and OpenAI API to analyze symptoms,
                predict diseases, and match patients with relevant specialists.
              </p>
              <p className="detail">
                <strong className="label ai">AI integration:</strong> OpenAI
                GPT-4 analyses the symptoms, a trained ML model served by Flask
                predicts likely diseases, and the result recommends verified
                doctors by specialty and location.
              </p>
              <p className="detail">
                <strong className="label problem">Problem:</strong> People
                struggle to understand what their symptoms mean and which
                specialist to see, which delays getting care.
              </p>
              <p className="detail">
                <strong className="label solved">What it solved:</strong> One
                flow that analyzes symptoms, predicts likely conditions, and
                points patients to the right specialist.
              </p>
              <p className="detail">
                <strong className="label login">Test login:</strong> Email:
                sazipettife-1746@yopmail.com , Password: owais2004
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>NextJS</li>

                <li>Flask</li>
                <li>OpenAI</li>
                <li>MongoDB</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg
                width="50"
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#23ce6b"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a
                  href="https://github.com/raza2004/rosilex-shopify-theme"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={githubIcon} alt="Visit site" />
                </a>
                <a
                  href="https://rosexious.myshopify.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Rosilex: AI Powered Luxury Skincare Store on Shopify</h3>
              <p>
                Built a custom Shopify theme for a Nordic luxury skincare brand
                with Liquid, GSAP and Lenis, featuring editorial animations,
                day/night mode and 12 languages, plus an AI skin quiz.
              </p>
              <p className="detail">
                <strong className="label ai">AI integration:</strong> A
                Cloudflare Worker sends quiz answers and an optional selfie to
                Google Gemini, which returns three real products from the live
                catalog, with a lighter model and rule based fallbacks.
              </p>
              <p className="detail">
                <strong className="label problem">Problem:</strong> Shoppers
                couldn't tell which skincare products suited their skin.
              </p>
              <p className="detail">
                <strong className="label solved">What it solved:</strong> A one
                minute AI quiz gives each visitor a personalised three step
                routine. It's consent based and never stores photos.
              </p>
              <p className="detail">
                <strong className="label login">Store password:</strong> Owais
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Shopify</li>
                <li>Gemini AI</li>
                <li>Cloudflare</li>
                <li>TypeScript</li>
                <li>GSAP</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg
                width="50"
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#23ce6b"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <title>Code</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a
                  href="https://github.com/raza2004/FlowForge"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={githubIcon} alt="Visit site" />
                </a>
                {/* <a
                  href="https://www.yolofood.pk/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a> */}
              </div>
            </header>
            <div className="body">
              <h3>FlowForge (AI Powered Project Management)</h3>
              <p>
                Currently building FlowForge, an AI augmented SaaS platform for project and workflow management think Jira's structure meets Linear's speed with an AI assistant that auto-assigns tasks, writes sprint summaries, and flags risks early. A full-stack, multi tenant app being engineered with .NET 8, Angular 18, PostgreSQL, and Redis.
              </p>
              <p className="detail">
                <strong className="label ai">AI integration:</strong> A RAG
                pipeline embeds tasks, comments and docs into a vector store, so
                the OpenAI powered assistant answers questions and writes
                summaries from the team's real project data, not generic output.
              </p>
              <p className="detail">
                <strong className="label problem">Problem:</strong> Teams lose
                time assigning tasks by hand, writing sprint summaries, and
                spotting risks too late.
              </p>
              <p className="detail">
                <strong className="label solved">What it solves:</strong> An AI
                assistant handles task assignment, sprint summaries, and early
                risk flags (in progress).
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>C#</li>
                <li>Dotnet</li>
                <li>Angular</li>
                <li>Redis</li>
                <li>PostgreSQL</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        {/* Row 2 */}
       <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg
                width="50"
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#23ce6b"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                {" "}
                <title>Folder</title>{" "}
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>{" "}
              </svg>
              <div className="project-links">
                <a
                  href="https://github.com/raza2004/cr-web"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={githubIcon} alt="Visit site" />
                </a>
                <a
                  href="https://cr-web-tau.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>{" "}
              </div>
            </header>
            <div className="body">
              <h3>Static Checkroom Website with Animations</h3>
              <p>
                {" "}
                Developed a serverless responive website using NextJS,
                TailwindCSS, GSAP, and framer-motion, enabling users to view
                detail of Checkroom and access details of it through an
                interactive UI, leveraging serverless architecture for
                scalability and cost-efficiency.{" "}
              </p>
              <p className="detail">
                <strong className="label problem">Problem:</strong> Visitors had
                no clear, engaging way to learn what Checkroom offers.
              </p>
              <p className="detail">
                <strong className="label solved">What it solved:</strong> A fast,
                animated, responsive site that presents Checkroom clearly, on
                serverless hosting that scales and keeps costs low.
              </p>
            </div>
            <footer>
              {" "}
              <ul className="tech-list">
                {" "}
                <li>NextJS</li> <li>Tailwind CSS</li>{" "}
                <li>Animation libraries</li>{" "}
              </ul>{" "}
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg
                width="50"
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#23ce6b "
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <title>Folder</title>{" "}
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>{" "}
              </svg>
              <div className="project-links">
                <a
                  href="https://github.com/raza2004/CR_PRO"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={githubIcon} alt="Visit site" />{" "}
                </a>
                <a
                  href="https://cr-pro.vercel.app"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>
                Checkroom PRO: Where Personal Fashion Stylists Find Their Style
                Solution
              </h3>
              <p>
                Developed solely a work management platform for personal fashion
                stylist to connect with their clients and speed up their
                experience, also allow clients and stylists to chat with each
                other.
              </p>
              <p className="detail">
                <strong className="label problem">Problem:</strong> Personal
                stylists juggled client communication and their work across
                scattered tools, which slowed them down.
              </p>
              <p className="detail">
                <strong className="label solved">What it solved:</strong> One
                platform where stylists manage their work and clients, and both
                sides chat in real time.
              </p>
              <p className="detail">
                <strong className="label login">Test login:</strong> Email:
                owaisraza@gmail.com , Password: owais2024
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>NextJS</li>
                <li>NodeJS</li>
                <li>Socket</li>
                <li>MongoDB</li>
              
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg
                width="50"
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#23ce6b"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a
                  href="https://github.com/raza2004/cr_mobile"
                  target="\_blank"
                  rel="noreferrer"
                >
                  <img src={githubIcon} alt="Visit site" />
                </a>
                <a
                  href="https://expo.dev/accounts/raza2004/projects/CR_Mobile/builds/3fda7361-0045-4b19-a53a-e501b280fd4b"
                  target="\_blank"
                  rel="noreferrer"
                >
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Checkroom Client App</h3>
              <p>
                Converted the Checkroom client web app (cr_client, built with
                Next.js) into a cross platform React Native mobile app. Clients
                can connect with their stylist, view stylist created work, and
                chat with the stylist in real time to discuss their needs.
              </p>
              <p className="detail">
                <strong className="label problem">Problem:</strong> Clients
                wanted to reach their stylist and see their work from their
                phones, but the web app wasn't built for mobile.
              </p>
              <p className="detail">
                <strong className="label solved">What it solved:</strong> A
                mobile app with the same features, so clients stay in touch with
                their stylist wherever they are.
              </p>
              <p className="detail">
                <strong className="label login">Test login:</strong> Email:
                babayaga-3880@yopmail.com , Password: Testing2024$
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React Native</li>
                <li>TypeScript</li>
                <li>Socket.io</li>
                <li>MongoDB</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        {/* TimeFlow System (hidden for now)
<ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg
                width="50"
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#23ce6b "
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <title>Folder</title>
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
              </svg>
              <div className="project-links">
                <a href="https://github.com/CodeVinayak/MediBook-Medical-Appointment-Scheduler-with-Health-History" target="_blank" rel="noreferrer">
                  <img src={githubIcon} alt="Visit site" />
                </a>
                <a href="https://dev.workspace.timeflowsystem.com/" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>TimeFlow System</h3>
              <p>
                Contributed to TimeFlow System in its initial phase, a construction industry SaaS platform bringing project management, quoting, finance, and compliance into a single tool. I served as the primary frontend developer across three separate web dashboards, translating Figma designs into production ready modules with Next.js and TypeScript.
              </p>
              <p className="detail">
                <strong className="label problem">Problem:</strong> Construction
                businesses managed projects, quotes, finance, and compliance in
                separate tools, losing time and visibility.
              </p>
              <p className="detail">
                <strong className="label solved">What it solved:</strong> Brings
                all of it into a single SaaS platform, with the frontend of
                three dashboards built from Figma designs.
              </p>
              <p className="detail">
                <strong className="label login">Test login:</strong> Email:
                Kamran8037@gmail.com , Password: 12345678
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>NextJS</li>
                <li>TypeScript</li>
                <li>Python</li>
                <li>AWS</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>
        */}

        {/* <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="https://justmedicalbooks.com/" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>MedicalBooks - Book Selling Site</h3>
              <p>
                This website sells medical books online and is popular with medical students. Medical students use it to buy books and acquire knowledge. The site has all kinds of medical books in one place.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Wordpress</li>
                <li>Woocommerce</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation> */}

        {/* <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="https://drrohitdamor.com" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Dr.Rohit Damor - Online Appointment Booking Site</h3>
              <p>
                This website allows people to easily book appointments with you online. It takes just a minute to schedule a meeting. This kind of site is helpful for booking appointments and not missing any potential clients. You should try this website to see how convenient and efficient it is.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Wordpress</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation> */}

        {/* <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="https://mitulindustries.com/" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Mitul Industries - Manufacturing Industries Site</h3>
              <p>
              This manufacturing industry website shows off products and helps the business get more customers and information online. Making products is important but making money from them is the goal. This site can help the business make more profit.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Wordpress</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation> */}

        {/* 
        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="https://mayatmaj.com/" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>Mayatmaj - Film Production Site</h3>
              <p>
                This agency website promotes post production, virtual production, and video marketing services. It shows previous client work and reviews to get more business. If you need help with production, this website can give you information and connect you with the right people.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Wordpress</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation> */}

        {/* <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="https://www.smartcornersproperties.com/" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>SmartCorners - Real Estate Properties Site</h3>
              <p>
              This real estate site displays land properties and helps buyers and sellers. Buyers can see lots of pictures, videos, and details about properties before visiting in person. It makes it easier for buyers to find what they want and helps sellers get more attention.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Wordpress</li>               
              </ul>
            </footer>
          </div>
        </ScrollAnimation> */}

        {/* <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
              <div className="project-links">
                <a href="https://madewithluv.in/" target="_blank" rel="noreferrer">
                  <img src={externalLink} alt="Visit site" />
                </a>
              </div>
            </header>
            <div className="body">
              <h3>MadeWithLuv - HomeDecor Site</h3>
              <p>
                This website sells home decor products and helps people decorate their homes. It is easy to find what you need, whether it's furniture or decorations. The site is useful for people who want to make their homes look nice and need some help.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Wordpress</li>
                <li>Woocommerce</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation> */}
      </div>
    </Container>
  );
}
